export default {
  methods: {
    email(value) {
      value = `mailto:` + value.replace("mailto:", "");
      window.location.href = value;
    },
  },
};
